/* istanbul ignore file */
import { mainApi } from "config/api";
import { getClientFor } from "infrastructure/http";
import { ILocale } from "infrastructure/localization";
import { IIndustry } from "ui/shared/models/common";

import { ITranslationHistoryFilterData, ITranslationHistoryItem } from "./TranslationHistory.state";

export interface ITermsTranslationsHistoryRequest {
  termId: string;
  filter: ITranslationHistoryFilterData;
}

export interface ITermsTranslationsHistoryResponse {
  data: ITranslationHistoryItem[];
}

export const getTermsTranslationHistory = async (request: ITermsTranslationsHistoryRequest): Promise<ITermsTranslationsHistoryResponse> => {
  return (
    await getClientFor(mainApi.name).get(`events/${request.termId}/translations`, {
      params: {
        locale: request.filter.currentLocale && request.filter.currentLocale.localeIdentifier,
        industry: request.filter.currentIndustry && request.filter.currentIndustry.isiCv4Code
      }
    })
  ).data;
};

export const getIndustries = async (filter?: string) => {
  const response = await getClientFor(mainApi.name).get<IIndustry[]>("/industries", { params: filter ? { filter: filter } : {} });
  return response.data;
};

export const getLocales = async (filter?: string) => {
  const response = await getClientFor(mainApi.name).get<ILocale[]>("/locales", { params: filter ? { filter: filter } : {} });
  return response.data;
};
